import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import BasicTreeSelect from '../../../../../components/BasicTreeSelect/BasicTreeSelect';
import { sp_card_setting } from '../../../../../assets/img';
import {
  POSITION_MOBILITY_PLAN_DETAIL_DEFAULT_SELECT_OPTIONS,
  POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME,
  POSITION_MOBILITY_PLAN_DETAIL_SELECT_OPTIONS,
} from './constants';
import { isEqual } from 'lodash';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setMobilitySettingsInTalentReview } from '../../../../Meeting/redux/agendaSlice';
import { talentReviewApi } from '../../../../../services/talentReviewApi';

const WrapperIcon = styled.div`
  padding: 16px;
  display: flex;
  justify-content: center;
  background-color: #00807c;

  img {
    height: 20px;
  }
`;

const PositionMobilityPlanDetailSelection = (props) => {
  const { mobilitySettings, setMobilitySettings, mobility, addTalent } = props;
  const [selectedOptions, setSelectedOptions] = useState(POSITION_MOBILITY_PLAN_DETAIL_DEFAULT_SELECT_OPTIONS);
  const { agendaId } = useParams();
  const dispatch = useDispatch();
  const roleActive = useSelector((state) => state.user.roleActive);

  const prevParams = useRef({ mobilitySettings });
  const updateMobilityPlanSettings = async () => {
    try {
      const params = {
        agenda_id: agendaId,
        staff_id: addTalent?.top_talent?.staff_id || null,
        plan: mobility?.plan,
        version: addTalent?.top_talent?.version || 0,
        mobility_settings: selectedOptions.map((m) => ({
          ...m,
          checked: true,
        })),
      };
      await talentReviewApi.updateMobilityPlanSettings(params, roleActive.roleId);
    } catch (error) {
      console.error(error);
    }
  };
  const handleApply = () => {
    setMobilitySettings(selectedOptions);
    if (agendaId && !isNaN(Number(agendaId))) {
      updateMobilityPlanSettings();
    }
    if (agendaId && isNaN(Number(agendaId))) {
      dispatch(setMobilitySettingsInTalentReview({ agendaId, mobilityId: mobility.idx, mobilitySettings: selectedOptions }));
    }
  };

  useEffect(() => {
    const paramsChanged = !isEqual(prevParams.current, { mobilitySettings });

    if (paramsChanged) {
      prevParams.current = { mobilitySettings };
      setSelectedOptions(mobilitySettings);
    }
  }, [mobilitySettings]);

  const prevSelectedOptions = useMemo(() => {
    return mobilitySettings;
  }, [JSON.stringify(mobilitySettings)]);

  return (
    <BasicTreeSelect
      placement="bottomRight"
      dropdownStyle={{ minWidth: 415, maxWidth: 415 }}
      valueSelectAll={POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.ALL}
      onApply={handleApply}
      options={POSITION_MOBILITY_PLAN_DETAIL_SELECT_OPTIONS}
      selectedOptions={selectedOptions}
      setSelectedOptions={setSelectedOptions}
      prevSelectedOption={prevSelectedOptions}
      listHeight={730}
      style={{ height: 30 }}
    >
      <WrapperIcon>
        <img src={sp_card_setting} />
      </WrapperIcon>
    </BasicTreeSelect>
  );
};

export default PositionMobilityPlanDetailSelection;
